import { route } from "typesafe-react-router";

export const homeRoutes = route("");
